import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { PriceFilteringRuleAction } from '@cbridge-packages/price-filtering-rules';
import { RulesManagementAction } from '@cbridge-modules/rules-management-page';

export const onValidatePriceFilteringRulesDoneEpic: IEpic = (action$) => action$.pipe(
  isTypeOfAndGetPayload(
    PriceFilteringRuleAction.validate.done,
  ),
  mergeMap((payload) => {
    return [RulesManagementAction.applyValidation(payload.result)];
  }),
);
